<div>
  <header class="header modal-header flex flex-col gap-2 place-content-between h-20">
    <div class="flex justify-between">
      <h1 class="py-1">Collection in dashboard</h1>
      <button mat-icon-button class="button-close" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>
</div>
<div>
  <div class="actions-container h-16 action-box tag-box w-full flex flex-row place-items-center">
    <!-- Search filter -->
    <div class="flex w-full justify-start items-center">
      <div class="w-[84%] px-7" *ngIf="!data['callFrom'] || data['callFrom'] !== 'collection-details-view'">
        <sp-search-field
          [maxWidth]="'400px'"
          (keyUpInput)="searchTextChanged($event)"
          (clearInput)="clearSearch($event)"
          [placeholder]="searchPlaceholder"
          (toggleMobileSearch)="toggleMobileSearch()"
        ></sp-search-field>
      </div>
    </div>
    <div class="flex w-full justify-start items-center">
      <div class="w-[84%] px-7">
        <span class="font-bold" i18n>Selected </span> <span class="font-bold">{{ selectedCollectionList.length }}/6</span>
        <span class="px-4" i18n>Drag to reorder</span>
      </div>
    </div>
  </div>
</div>
<div class="w-full h-[calc(100%-14rem)] py-4 px-8 overflow-hidden">
  <div class="published-collections w-[47%] mr-[3%] inline-block p-2 widget-bg-color h-full overflow-auto rounded-lg">
    <header class="w-full px-3">
      <p class="w-1/6 inline-block" i18n></p>
      <p class="w-2/6 inline-block" i18n>Asset</p>
      <p class="w-3/6 inline-block px-2" i18n>Name</p>
    </header>
    <div *ngIf="collectionsList && collectionsList.length; else noFilesAdded1" class="asset-preivew overflow-y-auto" style="--asset-item-padding: 0.7rem; --asset-item-gap: 1rem">
      <ol class="asset-preview-list">
        <li *ngFor="let file of collectionsList; let i = index" class="asset-preview-item my-2">
          <thehubz-collection-select-view
            [item]="file"
            [index]="i"
            [disableCheckbox]="selectedCollectionList && selectedCollectionList.length === 6"
            [published]="true"
            (updateSelection)="updateSelection($event)"
            [editFlag]="true"
            class="elevated rounded"
          ></thehubz-collection-select-view>
        </li>
      </ol>
    </div>

    <ng-template #noFilesAdded1>
      <div class="flex w-full h-full justify-center items-center" i18n>No collection available</div>
    </ng-template>
  </div>

  <div class="selected-collections w-[47%] ml-[3%] inline-block p-2 widget-bg-color h-full overflow-auto rounded-lg">
    <header class="w-full px-3">
      <p class="w-1/6 inline-block" i18n></p>
      <p class="w-2/6 inline-block" i18n>Asset</p>
      <p class="w-3/6 inline-block px-2" i18n>Name</p>
    </header>
    <div *ngIf="selectedCollectionList && selectedCollectionList.length; else noFilesAdded" class="asset-preivew overflow-y-auto" style="--asset-item-padding: 0.7rem; --asset-item-gap: 1rem">
      <ol class="asset-preview-list" #selectedCollectionList1="cdkDropList" cdkDropList [cdkDropListData]="selectedCollectionList" (cdkDropListDropped)="drop($any($event))">
        <li *ngFor="let file of selectedCollectionList; let i = index" cdkDrag [cdkDragData]="file" class="asset-preview-item my-2">
          <thehubz-collection-select-view
            [item]="file"
            [published]="false"
            [index]="i"
            (updateSelection)="updateSelection($event)"
            [editFlag]="true"
            class="elevated rounded"
          ></thehubz-collection-select-view>
        </li>
      </ol>
    </div>

    <ng-template #noFilesAdded>
      <div class="flex w-full h-full justify-center items-center" i18n>No collection available</div>
    </ng-template>
  </div>
</div>
<footer class="footer h-30">
  <div class="button-row">
    <div class="right-actions float-right inline-block py-2 px-5">
      <button type="submit" mat-flat-button class="w-auto button-primary inline-flex gap-1 icon-right" (click)="applyChanges()">
        <span i18n> Apply </span>
      </button>
    </div>
  </div>
</footer>
